<template>
  <v-container :pa-0="$vuetify.breakpoint.smAndDown">
    <v-layout>
      <v-flex>
        <v-card :elevation="$vuetify.breakpoint.smAndDown ? 0 : 2">
          <v-tabs
            v-model="active"
            color="primary"
            dark
            slider-color="accent"
            v-show="$vuetify.breakpoint.xsOnly"
          >
            <v-tab
              v-for="tab in tabs"
              :key="tab.to"
              ripple
            >
              <router-link :to="{name: tab.to}" class="tab-link">{{ tab.title }}</router-link>

            </v-tab>
          </v-tabs>
          <v-layout row>
            <v-flex :d-flex="$vuetify.breakpoint.smAndUp" lg3 md3 sm4 xs0 class="hidden-xs-only">
              <v-list dense style="border-right: 1px solid #ccc;">
                <v-list-tile
                  v-for="tab in tabs"
                  :key="tab.title"
                  :to="{name: tab.to}"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{tab.title}}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
            <v-flex :d-flex="$vuetify.breakpoint.smAndUp" lg9 md9 sm8 xs12>
              <transition name="fade-transition" mode="out-in">
                <router-view></router-view>
              </transition>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'profile',
  data () {
    return {
      active: null,
      tabs: [
        {
          title: 'Настройки',
          to: 'profile'
        },
        {
          title: 'Изменение пароля',
          to: 'change_password'
        }
      ]
    }
  }
}
</script>

<style scoped>
  .tab-link {
    text-decoration: none;
    color: white;
  }
</style>
